export const URGENT = {
  value: "URGENT",
  key: "members.followUps.priorities.urgent",
};
export const TWODAYS = {
  value: "48H",
  key: "members.followUps.priorities.twoDays",
};
export const MEDIUM = {
  value: "MEDIUM",
  key: "members.followUps.priorities.medium",
};

export default [URGENT, TWODAYS, MEDIUM];

export const ENUM_DICT = {
  URGENT,
  TWODAYS,
  MEDIUM,
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/notes/enums/followUpPriorities.js